// frontend/src/pages/PaymentFailure.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PaymentFailure = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const params = new URLSearchParams(location.search);
    const errorMessage = params.get('error') || 'Ha ocurrido un problema con tu pago.';
    const paymentId = params.get('payment_id');

    return (
        <div
            className="min-h-screen flex items-center justify-center px-4 py-12"
            style={{ backgroundColor: '#0A1929' }}
        >
            <div className="w-full max-w-md">
                <div
                    className="rounded-[24px] overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.5)]"
                    style={{ backgroundColor: '#0E2238', border: '2px solid rgba(255,255,255,0.1)' }}
                >
                    {/* Icon + título */}
                    <div className="px-8 pt-10 pb-7 text-center"
                        style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                        <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-5"
                            style={{ backgroundColor: 'rgba(239,68,68,0.15)', border: '2px solid #EF4444' }}>
                            <span className="text-4xl">❌</span>
                        </div>
                        <h2 className="text-2xl font-extrabold text-white mb-2">Pago Rechazado</h2>
                        <p className="text-white/50 text-sm">{errorMessage}</p>
                    </div>

                    {/* Detalle */}
                    {paymentId && (
                        <div className="px-8 py-5"
                            style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                            <p className="text-xs font-bold uppercase tracking-widest text-white/30 mb-4">Detalle</p>
                            <div className="flex justify-between items-center text-sm">
                                <span className="text-white/40">ID de pago</span>
                                <span className="text-white font-semibold">{paymentId}</span>
                            </div>
                        </div>
                    )}

                    {/* Botones */}
                    <div className="px-8 py-6 flex flex-col gap-3">
                        <button
                            onClick={() => navigate('/recharge')}
                            className="w-full h-12 rounded-[14px] font-bold text-sm uppercase tracking-wider
                                       transition-transform hover:scale-[1.02] active:scale-[0.98]"
                            style={{ backgroundColor: '#FCE503', color: '#122436', border: '2px solid #E5CF03' }}
                        >
                            Intentar nuevamente
                        </button>
                        <button
                            onClick={() => navigate('/')}
                            className="w-full h-12 rounded-[14px] font-bold text-sm uppercase tracking-wider
                                       text-white/50 hover:text-white/80 transition-colors"
                        >
                            Volver al inicio
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailure;
